import React from 'react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import ProductDetails from '../super-savings/product-details/ProductDetails'
import {
  bought,
  boughtContainer,
  boughtTitle,
  boughtTop,
  boughtWrapper,
  productsWrapper,
  swiperSlide,
} from './customers-also-bought.module.scss'

export default function CustomersAlsoBought({ products }) {
  let displayProducts =
    products.length > 4 && products.length < 9
      ? [...products, ...products]
      : products

  return (
    <section className={boughtContainer}>
      <div className={bought}>
        <div className={boughtWrapper}>
          <div className={boughtTitle}>Customers Also Bought</div>
          <div className={productsWrapper}>
            <Swiper
              modules={[Navigation, Pagination]}
              spaceBetween={10}
              slidesPerView={'auto'}
              navigation={true}
              // cssMode={true}
              pagination={{ clickable: true }}
              loop={true}
            >
              {displayProducts.map((product, index) => (
                <SwiperSlide key={index} className={swiperSlide}>
                  <ProductDetails
                    product={product}
                    summary={{ node: product }}
                  />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  )
}
